import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { DeliveryIntervalSelectContainer } from "../../../../../../../../components/DeliveryIntervalSelect/modules/EcommContent/components/DeliveryIntervalSelect/DeliveryIntervalSelectContainer.js";
import { useSolutionsEcommContext } from "../../../../../../../context/modules/EcommContent/SolutionsEcommContent/context/SolutionsEcommContext.js";
const SolutionsDeliveryIntervalSelect = ({ className }) => {
  const { actions, state } = useSolutionsEcommContext();
  const { deliveryInterval } = state.configurations.subscriptionPurchaseConfigurations;
  const {
    deliveryInterval: { showError },
    invalidSubmissionsCount
  } = state.configurator;
  React.useEffect(() => {
    if (showError) {
      toast.failed("products.deliveryInterval.error");
    }
  }, [showError, invalidSubmissionsCount]);
  return /* @__PURE__ */ React.createElement(
    DeliveryIntervalSelectContainer,
    {
      className,
      hasError: showError,
      deliveryInterval,
      onIntervalSelection: actions.updateDeliveryInterval
    }
  );
};
export {
  SolutionsDeliveryIntervalSelect
};
//# sourceMappingURL=SolutionsDeliveryIntervalSelect.js.map
